import autosize from 'autosize';

function Autosize($container) {
  autosize($container.find('textarea'));
}

export default Autosize;
